module.exports = __webpack_public_path__ + "4c4bf136fe5a2eb684153ecd7c20c611.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/team/Leadership_AlexP_0.jpg
// module id = 554
// module chunks = 0